import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { DashboardKpiOverview, HttpResponse } from "@/types";

export function useGetDashboardKpis(userId: number | null) {
  return useQuery({
    queryKey: ["dashboard-kpis", userId],
    queryFn: async () => {
      const userIdParam = userId === null ? "" : `?userId=${userId.toString()}`;
      const res = await guacHttpClient.get<
        DashboardKpiOverview,
        HttpResponse<DashboardKpiOverview>
      >(`dashboard/kpis${userIdParam}`);
      return res.data;
    },
  });
}
